import api from '../utils/baseUrl';

class CityService {
    async getCitiesByCountry(selectedCountry: string, selectedState?: string | null) {
        try {
            const response = await api.get(`cities/${selectedCountry}`, {
                params: selectedState ? {state: selectedState} : undefined
            });
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error('Error fetching cities:', error);
            return [];
        }
    }
}

export default new CityService();
